/**
 * @file Renders the title, subtitle and text header used on
 * investment-related pages.
 */
import type { CSSProperties } from "react";
import { Typography, Space } from "antd";
import type { TitleProps } from "antd/es/typography/Title";

import { isMobile } from "@components/Constants";

const { Title, Text } = Typography;

type Props = {
  text?: string;
  style?: CSSProperties;
  title?: string;
  subtitle?: string;
  titleLevel?: TitleProps["level"];
};

/**
 * Renders a centered subtitle, title and optional supporting text.
 */
const InvestmentHeader = ({
  text = "",
  style = {},
  title = "",
  subtitle = "",
  titleLevel = isMobile ? 3 : 1,
}: Props): JSX.Element => {
  return (
    <Space
      size={4}
      style={{ width: "100%", ...style }}
      direction="vertical"
    >
      <center>
        <Text type="secondary" strong>
          {subtitle}
        </Text>
      </center>

      <Title
        level={titleLevel}
        style={{ marginTop: 0, marginBottom: 0, textAlign: "center" }}
      >
        {title}
      </Title>

      {
        text && (
          <center style={{ marginTop: 2 }}>
            <Text>
              {text}
            </Text>
          </center>
        )
      }
    </Space>
  );
};

export default InvestmentHeader;
